<section class="section1">

    <h1 class="display-4 text-center pt-4 " ><a>Contact Us</a></h1>


    <section class="container text-center">
        <div class="row">
            <div class="col-md-4 col-12 point-tab">
                <div class="btn">
                    <h1 class="heading-point" style="color:white" >Mobile No</h1>
                    <p href="whatsapp://send?phone=+918006060802" style="color: white !important;"><i class="fa fa-whatsapp"  aria-hidden="true"></i> +91 80060 60802</p>
                    <p><i class="fa fa-phone" aria-hidden="true"></i><a href="tel:+918006060805" style="color: white !important;"> +91 80060 60805</a></p>
                </div>
            </div>
            <div class="col-md-4 col-12"></div>
            <br>
            <div class="col-md-4 col-12 point-tab">
                <div>
                    <h1 class="heading-point">Email</h1>
                    <p>help@doqmatokens.com</p>
                </div>
            </div>
        </div>
        <!-- <div class="row">
            <div class="col-2"></div>
            <div class="col-4">
                <div>
                    <h1></h1>
                </div>
            </div>
            <div class="col-2"></div>
        </div> -->
    </section>
</section>
<app-footer></app-footer>

  <!-- End Footer -->

  <a href="#" id="myBtn" class="back-to-top" style="display: none;">
    <i class="bi bi-arrow-up"></i>
  </a>
